import React from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { FeedbackItem } from './FeedbackItem';
import { HelpCenterStateContainer } from './HelpCenterStateContainers';

export const FeedbackItemWrapper = () => {
	return (
		<Subscribe to={[HelpCenterStateContainer]}>
			{(helpCenterState: HelpCenterStateContainer) => (
				<FeedbackItem showGlobalFeedbackCollector={helpCenterState.showGlobalFeedbackCollector} />
			)}
		</Subscribe>
	);
};
